import { render, staticRenderFns } from "./switch_button.vue?vue&type=template&id=411789d4&"
import script from "./switch_button.vue?vue&type=script&lang=js&"
export * from "./switch_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20251203080612/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('411789d4')) {
      api.createRecord('411789d4', component.options)
    } else {
      api.reload('411789d4', component.options)
    }
    module.hot.accept("./switch_button.vue?vue&type=template&id=411789d4&", function () {
      api.rerender('411789d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/form/switch_button.vue"
export default component.exports